import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleSummaryReportByGroup } from 'domain/usecases';

export class RemoteHandleSummaryReportByGroup
  implements HandleSummaryReportByGroup
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleSummaryReportByGroup.Result>,
  ) {}

  async execute(
    params: HandleSummaryReportByGroup.Params,
  ): Promise<HandleSummaryReportByGroup.Result> {
    const { type, ...restArgs } = params;
    const requestUrl = generateUrl(this.url + `/${type}`, restArgs as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: params.type === '2' ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
